import { render, staticRenderFns } from "./bind-client-group-table.vue?vue&type=template&id=7c62595f&scoped=true"
import script from "./bind-client-group-table.vue?vue&type=script&lang=js"
export * from "./bind-client-group-table.vue?vue&type=script&lang=js"
import style0 from "./bind-client-group-table.vue?vue&type=style&index=0&id=7c62595f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62595f",
  null
  
)

export default component.exports